<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Consulta Fatura Despesa</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a @click="onCreate()" v-b-tooltip title="Cadastrar"
                      ><i class="ft-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a @click="onApprove()" v-b-tooltip title="Aprovar Faturas"
                      ><i class="fa fa-check"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onDisapprove()"
                      v-b-tooltip
                      title="Reprovar Faturas"
                      ><i class="fa fa-times"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermission('unidade.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inativar Registros"
                      v-if="getPermission('unidade.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'fatura_despesa'">
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/faturadespesa"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="fatdes_id"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="faturadespesa-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="vlr_fatura" slot-scope="props">
                      <span>{{ props.rowData.vlr_fatura }}</span>
                    </template>
                    <template slot="dt_emi" slot-scope="props">
                      <span>{{ DateFormat(props.rowData.dt_emi) }}</span>
                    </template>
                    <template slot="dt_vencto" slot-scope="props">
                      <span>{{ DateFormat(props.rowData.dt_vencto) }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 4"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-secondary"
                        v-if="props.rowData.status.valor == 5"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="unidade" slot-scope="props">
                      <span>{{
                        props.rowData.unidade.cd +
                          "-" +
                          props.rowData.unidade.descr
                      }}</span>
                    </template>
                    <template slot="transportadora" slot-scope="props">
                      <span
                        v-if="props.rowData.pessoa.pessoa_juridica != null"
                        >{{
                          props.rowData.pessoa.pessoa_juridica.razao_social
                        }}</span
                      >
                      <span v-if="props.rowData.pessoa.pessoa_fisica != null">{{
                        props.rowData.pessoa.pessoa_fisica.nome
                      }}</span>
                    </template>
                    <template slot="vlr_pre_fatura" slot-scope="props">
                      <span
                        v-if="props.rowData.fatura_despesa_trecho.length > 0"
                      >{{ props.rowData.vlr_custo }}</span>
                      <span
                        v-if="props.rowData.pre_fatura_despesa != null"
                      >{{ props.rowData.pre_fatura_despesa.vlr_pre_fatura }}</span>
                    </template>
                    <template slot="status_envio_integracao" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status_envio_integracao.valor == 1"
                        >{{ props.rowData.status_envio_integracao.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status_envio_integracao.valor == 2"
                        >{{ props.rowData.status_envio_integracao.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status_envio_integracao.valor == 3"
                        >{{ props.rowData.status_envio_integracao.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onApprove([props.rowData.fatdes_id])"
                          v-b-tooltip
                          title="Aprovar"
                          ><i class="fa fa-check"></i
                        ></a>
                        <a
                          @click="onDisapprove([props.rowData.fatdes_id])"
                          v-b-tooltip
                          title="Reprovar"
                          ><i class="fa fa-times"></i
                        ></a>
                        <a
                          v-if="
                            getPermissionFw('faturadespesa.reenvio') &&
                              props.rowData.status_envio_integracao.valor != 2
                          "
                          @click="onReenvioErp(props.rowData.fatdes_id)"
                          v-b-tooltip
                          title="Reenviar ERP"
                          ><i class="fa fa-reply"></i
                        ></a>
                        <a
                          @click="sendDoc(props.rowData.fatdes_id)"
                          v-b-tooltip
                          title="Enviar Documento"
                          ><i class="fa fa-picture-o"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SendDocForm ref="senddocform" :rota="'faturadespesa'" />
      <FaturaDespesaForm ref="faturadespesaform" />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import moment from "moment";
import FaturaDespesaFilterBarVue from "./FaturaDespesaFilterBar.vue";
import FaturaDespesaDetalhes from "./FaturaDespesaDetalhes.vue";
import FaturaDespesaForm from "./FaturaDespesaForm.vue";
import SendDocForm from "./SendDocForm.vue";

Vue.component("faturadespesa-detalhes", FaturaDespesaDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    FaturaDespesaDetalhes,
    VuetablePaginationInfo,
    FaturaDespesaForm,
    SendDocForm,
    "vuetable-filterbar": FaturaDespesaFilterBarVue,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      optionsStatus: [],
      optionsStatusErp: [],
      optionsTpFatura: [],
      optionsParamMotivo: [],
      optionsParamMotivoNf: [],
      tpMotivoSelected: [],
      paramMotivoSelected: [],
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      isFullscreen: false,
      helpForm: new Form({ recordCollection: [], status: "", fatdes_id: "" }),
      form: new Form({
        fatdes_ids: [],
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "tp_fatura.descr",
          title: "Tipo de Documento",
          sortField: "tp_fatura",
        },
        {
          name: "num_fiscal",
          title: "N° Fatura",
          sortField: "num_fiscal",
        },
        {
          name: "serie",
          title: "Serie",
          sortField: "serie",
        },
        {
          name: "vlr_fatura",
          title: "Valor Fatura",
          sortField: "vlr_fatura",
        },
        {
          name: "__slot:vlr_pre_fatura",
          title: "Valor Pré Fatura",
          sortField: "vlr_fatura",
        },
        {
          name: "__slot:dt_emi",
          title: "Data Emissão",
          sortField: "dt_emi",
        },
        {
          name: "__slot:dt_vencto",
          title: "Data Vencimento",
          sortField: "dt_vencto",
        },
        {
          name: "pre_fatura_despesa.num_fiscal",
          title: "N° Pré-Fatura",
          sortField: "",
        },
        {
          name: "__slot:transportadora",
          title: "Transportadora",
        },
        {
          name: "__slot:status_envio_integracao",
          title: "Status ERP",
          sortField: "status",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function(data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.$refs.vuetable.selectedTo = null;
      this.$refs.vuetable.selectedTo = [];
      this.moreParams = {
        tp_fatura: data_filter.tp_fatura.value,
        num_fiscal: data_filter.num_fiscal,
        dt_emi_ini: data_filter.dt_emi_ini,
        dt_emi_fim: data_filter.dt_emi_fim,
        status: data_filter.status.value,
        status_erp: data_filter.status_erp.value,
        transportadora: data_filter.transportadora.value,
        param_motivo: data_filter.param_motivo,
      };
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      this.loadingData = true;
      this.$refs.vuetable.selectedTo = null;
      this.$refs.vuetable.selectedTo = [];
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onReenvioErp(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.fatdes_id = id;
      this.helpForm
        .patch("/api/faturadespesa/reenvio")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.fatdes_id);
    },
    sendDoc(data) {
      this.$refs.senddocform.onCreate(data);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    DateFormat: function(date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.unidade_id);
      }
    },
    onCreate() {
      this.$refs.faturadespesaform.onCreate();
    },
    onEdit(data, index) {
      this.$refs.faturadespesaform.onEdit(data);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onApprove(id) {
      this.loading = true;
      this.isDisabled = true;
      if (!id) {
        this.form.fatdes_ids = this.$refs.vuetable.selectedTo;
      } else {
        this.form.fatdes_ids = id;
      }

      this.form
        .patch("/api/faturadespesa/liberar")
        .then((response) => {
          new ReturnApi(response, this);
          this.$refs.vuetable.selectedTo = null;
          this.$refs.vuetable.selectedTo = [];
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
          console.log("ERRO");
        });
    },
    onDisapprove(id) {
      this.loading = true;
      this.isDisabled = true;
      if (!id) {
        this.form.fatdes_ids = this.$refs.vuetable.selectedTo;
      } else {
        this.form.fatdes_ids = id;
      }

      this.form
        .patch("/api/faturadespesa/cancelar")
        .then((response) => {
          new ReturnApi(response, this);
          this.$refs.vuetable.selectedTo = null;
          this.$refs.vuetable.selectedTo = [];
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/faturadespesa/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsStatus.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.status_erp.forEach((obj) => {
            this.optionsStatusErp.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_fatura.forEach((obj) => {
            this.optionsTpFatura.push({
              text: obj.descr,
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.param_motivo.forEach((obj) => {
            this.optionsParamMotivo.push({
              text: obj.descr,
              label: obj.descr,
              value: obj.parmot_id,
            });
          });

          response.param_motivo_nf.forEach((obj) => {
            this.optionsParamMotivoNf.push({
              label: obj.descr,
              value: obj.parmot_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push(data.gracolent_id);
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.faturadespesaform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>
